import { ApolloProvider } from '@apollo/client';
import App, { AppContext } from 'next/app';
import type { AppProps } from 'next/app';
import basicAuthMiddleware from 'nextjs-basic-auth-middleware';

import { useApollo } from 'apollo-client';

import AppContainer from 'containers/app';
import LoadingContainer from 'containers/loading';

import { STANDS_NAMES } from 'utils/envs';
import { setupDayjsConfig } from 'utils/dates';

import 'styles/globals.css';

interface IProps extends AppProps {
  Component: any; // TODO: навесить тип
}

setupDayjsConfig();

const layouts: any = {
  app: AppContainer,
  loading: LoadingContainer,
};

function MyApp({ Component, pageProps }: IProps) {
  const apolloClient = useApollo(pageProps);
  const componentLayout = Component.layout;
  const Layout = componentLayout ? layouts[componentLayout] : layouts['app'];

  return (
    <ApolloProvider client={apolloClient}>
      <Layout>
        <Component {...pageProps} />
      </Layout>
    </ApolloProvider>
  );
}

// https://nextjs.org/docs/advanced-features/custom-app
MyApp.getInitialProps = async (appContext: AppContext) => {
  // настройка BASIC-авторизации (для тестовых стендов)
  if (
    STANDS_NAMES.includes(process.env.NEXT_PUBLIC_WERF_ENV as string) &&
    appContext.ctx.req &&
    appContext.ctx.res
  ) {
    await basicAuthMiddleware(appContext.ctx.req, appContext.ctx.res);
  }

  const appProps = await App.getInitialProps(appContext);

  return { ...appProps };
};

export default MyApp;
